import * as React from 'react';

interface ErrorBoundariesComponentProps {
  data?: any;
}
interface ErrorBoundariesComponentState {
  hasError: boolean;
}

class ErrorBoundariesComponent extends React.Component<
  ErrorBoundariesComponentProps,
  ErrorBoundariesComponentState
  > {
  public state: ErrorBoundariesComponentState = {
    hasError: false
  };

  public componentDidUpdate(prevProps: ErrorBoundariesComponentProps) {
    if (!!this.props.data && this.props.data !== prevProps.data) {
      this.setState({
        hasError: false
      });
    }
  }

  public componentDidCatch(error: any, info: any) {

    this.setState({ hasError: true });

  }
  public render() {
    if (this.state.hasError) {
      // You can render any custom fallback UI
      return <h1>It's known bug, chart can't be rendered</h1>;
    }
    return this.props.children;
  }
}

export const ErrorBoundaries = ErrorBoundariesComponent;
